import { render } from "./AdvancePayment.vue?vue&type=template&id=b8cb8d86&scoped=true"
import script from "./AdvancePayment.vue?vue&type=script&lang=js"
export * from "./AdvancePayment.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=b8cb8d86&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cb8d86"]])

export default __exports__